// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./advanced.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import CSS Variables */

/* Import Advanced CSS Features */

/* ==========================================================================
   CSS Reset and Normalize
   ========================================================================== */

/* Modern CSS Reset */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Remove default margins and paddings */
* {
  margin: 0;
  padding: 0;
}

/* HTML and Body */
html {
  font-size: 16px;
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
  line-height: 1.15;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-normal);
  color: var(--color-text);
  background-color: var(--color-background);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: "kern" 1;
  font-kerning: normal;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Screen Reader Only Content */
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.sr-only:focus {
  position: static !important;
  width: auto !important;
  height: auto !important;
  padding: inherit !important;
  margin: inherit !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: inherit !important;
}

/* Remove list styles on ul, ol elements with a list role */
ul[role='list'],
ol[role='list'] {
  list-style: none;
}

/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}

/* Set core body defaults */
body {
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img,
picture,
svg {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Remove built-in form typography styles */
input,
button,
textarea,
select {
  font: inherit;
}

/* Remove animations for people who've turned them off */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
   scroll-behavior: auto;
  }
  
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* ==========================================================================
   Typography System
   ========================================================================== */

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-tight);
  color: var(--color-text);
  margin-bottom: var(--spacing-4);
  text-wrap: balance;
}

h1 {
  font-size: var(--font-size-5xl);
  font-weight: var(--font-weight-extrabold);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}

h2 {
  font-size: var(--font-size-4xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}

h3 {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-snug);
}

h4 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
}

h5 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}

h6 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

/* Paragraphs and Text */
p {
  margin-bottom: var(--spacing-4);
  color: var(--color-text-secondary);
  line-height: var(--line-height-relaxed);
  text-wrap: pretty;
  orphans: 2;
  widows: 2;
}

p:last-child {
  margin-bottom: 0;
}

/* Strong and emphasis */
strong,
b {
  font-weight: var(--font-weight-bold);
  color: var(--color-text);
}

em,
i {
  font-style: italic;
}

/* Small text */
small {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

/* Code and preformatted text */
code,
kbd,
samp,
pre {
  font-family: var(--font-family-mono);
  font-size: 0.9em;
}

code {
  background-color: var(--color-surface);
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

pre {
  background-color: var(--color-surface);
  padding: var(--spacing-4);
  border-radius: var(--radius-md);
  overflow-x: auto;
  border: 1px solid var(--color-border);
  line-height: var(--line-height-relaxed);
}

pre code {
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;
}

/* Blockquotes */
blockquote {
  margin: var(--spacing-6) 0;
  padding: var(--spacing-4) var(--spacing-6);
  border-left: 4px solid var(--color-primary);
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  font-style: italic;
  color: var(--color-text-secondary);
}

blockquote p {
  margin-bottom: var(--spacing-2);
}

blockquote p:last-child {
  margin-bottom: 0;
}

blockquote cite {
  display: block;
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  font-style: normal;
}

blockquote cite::before {
  content: "— ";
}

/* ==========================================================================
   Links and Navigation
   ========================================================================== */

a {
  color: var(--color-primary);
  text-decoration: none;
  transition: color var(--transition-fast);
  cursor: pointer;
}

a:hover {
  color: var(--color-primary-light);
  text-decoration: underline;
}

a:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

a:focus:not(:focus-visible) {
  outline: none;
}

a:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

/* External links */
a[href^="http"]:not([href*="s-cubus.com"]):not(.btn)::after {
  content: " ↗";
  font-size: 0.8em;
  opacity: 0.7;
}

a.btn:hover {
  text-decoration: none;
}

/* ==========================================================================
   Lists
   ========================================================================== */

ul, ol {
  margin-bottom: var(--spacing-4);
  padding-left: var(--spacing-6);
}

ul {
  list-style-type: disc;
}

ol {
  list-style-type: decimal;
}

li {
  margin-bottom: var(--spacing-2);
  color: var(--color-text-secondary);
  line-height: var(--line-height-relaxed);
}

li:last-child {
  margin-bottom: 0;
}

/* Nested lists */
li ul,
li ol {
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
}

/* Description lists */
dl {
  margin-bottom: var(--spacing-4);
}

dt {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  margin-bottom: var(--spacing-1);
}

dd {
  margin-bottom: var(--spacing-3);
  margin-left: var(--spacing-4);
  color: var(--color-text-secondary);
}

/* ==========================================================================
   Tables
   ========================================================================== */

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--spacing-6);
  background-color: var(--color-surface);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

thead {
  background-color: var(--color-surface-elevated);
}

th,
td {
  padding: var(--spacing-3) var(--spacing-4);
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

th {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  font-size: var(--font-size-sm);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

td {
  color: var(--color-text-secondary);
}

tbody tr:hover {
  background-color: var(--color-surface);
}

tbody tr:last-child td {
  border-bottom: none;
}

/* ==========================================================================
   Forms and Inputs
   ========================================================================== */

/* Form elements inherit font properties */
input,
textarea,
select,
button {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

/* Form controls */
input,
textarea,
select {
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  transition: all var(--transition-fast);
  appearance: none;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}

input::placeholder,
textarea::placeholder {
  color: var(--color-text-muted);
  opacity: 1;
}

/* Specific input types */
input[type="search"] {
  -webkit-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Textarea */
textarea {
  resize: vertical;
  min-height: 100px;
}

/* Select */
select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right var(--spacing-3) center;
  background-repeat: no-repeat;
  background-size: 16px 12px;
  padding-right: var(--spacing-10);
}

/* Checkboxes and radio buttons */
input[type="checkbox"],
input[type="radio"] {
  width: auto;
  margin-right: var(--spacing-2);
  accent-color: var(--color-primary);
}

/* Labels */
label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
  cursor: pointer;
}

/* Fieldsets */
fieldset {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-4);
  margin-bottom: var(--spacing-4);
}

legend {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  padding: 0 var(--spacing-2);
}

/* ==========================================================================
   Buttons
   ========================================================================== */

button {
  cursor: pointer;
  border: none;
  border-radius: var(--radius-md);
  padding: var(--spacing-3) var(--spacing-6);
  font-weight: var(--font-weight-medium);
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  transition: all var(--transition-fast);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

button:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

button:focus:not(:focus-visible) {
  outline: none;
}

button:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Button Variants */
.btn-primary {
  background-color: var(--color-primary);
  color: white;
  border: 2px solid var(--color-primary);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-primary-light);
  border-color: var(--color-primary-light);
  color: #f59e0b;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.btn-secondary {
  background-color: var(--color-secondary);
  color: white;
  border: 2px solid var(--color-secondary);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--color-secondary-light);
  border-color: var(--color-secondary-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-outline {
  background-color: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}

.btn-outline:hover:not(:disabled) {
  background-color: var(--color-primary);
  color: white;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-ghost {
  background-color: transparent;
  color: var(--color-text);
  border: 2px solid transparent;
}

.btn-ghost:hover:not(:disabled) {
  background-color: var(--color-surface);
  border-color: var(--color-border);
}

.btn-success {
  background-color: var(--color-success);
  color: white;
  border: 2px solid var(--color-success);
}

.btn-success:hover:not(:disabled) {
  background-color: var(--color-success-light);
  border-color: var(--color-success-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-warning {
  background-color: var(--color-warning);
  color: white;
  border: 2px solid var(--color-warning);
}

.btn-warning:hover:not(:disabled) {
  background-color: var(--color-warning-light);
  border-color: var(--color-warning-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-error {
  background-color: var(--color-error);
  color: white;
  border: 2px solid var(--color-error);
}

.btn-error:hover:not(:disabled) {
  background-color: var(--color-error-light);
  border-color: var(--color-error-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* ==========================================================================
   Media Elements
   ========================================================================== */

/* Images */
img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: var(--radius-md);
}

/* Figures */
figure {
  margin: var(--spacing-6) 0;
}

figcaption {
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  text-align: center;
  font-style: italic;
}

/* Audio and Video */
audio,
video {
  width: 100%;
  height: auto;
  border-radius: var(--radius-md);
}

/* ==========================================================================
   Utility Classes - Layout
   ========================================================================== */

.container {
  width: 100%;
  max-width: var(--container-xl);
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

.container-sm { max-width: var(--container-sm); }
.container-md { max-width: var(--container-md); }
.container-lg { max-width: var(--container-lg); }
.container-2xl { max-width: var(--container-2xl); }

/* Flexbox Utilities */
.flex { display: flex; }
.inline-flex { display: inline-flex; }
.flex-col { flex-direction: column; }
.flex-row { flex-direction: row; }
.flex-wrap { flex-wrap: wrap; }
.flex-nowrap { flex-wrap: nowrap; }

.items-start { align-items: flex-start; }
.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.items-stretch { align-items: stretch; }
.items-baseline { align-items: baseline; }

.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }
.justify-evenly { justify-content: space-evenly; }

.flex-1 { flex: 1 1 0%; }
.flex-auto { flex: 1 1 auto; }
.flex-initial { flex: 0 1 auto; }
.flex-none { flex: none; }

/* Grid Utilities */
.grid { display: grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }

.gap-1 { gap: var(--spacing-1); }
.gap-2 { gap: var(--spacing-2); }
.gap-3 { gap: var(--spacing-3); }
.gap-4 { gap: var(--spacing-4); }
.gap-6 { gap: var(--spacing-6); }
.gap-8 { gap: var(--spacing-8); }

/* Spacing Utilities */
.m-0 { margin: 0; }
.m-auto { margin: auto; }
.mx-auto { margin-left: auto; margin-right: auto; }
.my-auto { margin-top: auto; margin-bottom: auto; }

.p-0 { padding: 0; }
.p-4 { padding: var(--spacing-4); }
.p-6 { padding: var(--spacing-6); }
.p-8 { padding: var(--spacing-8); }

.px-4 { padding-left: var(--spacing-4); padding-right: var(--spacing-4); }
.py-4 { padding-top: var(--spacing-4); padding-bottom: var(--spacing-4); }

/* Text Utilities */
.text-left { text-align: left; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.text-justify { text-align: justify; }

.text-xs { font-size: var(--font-size-xs); }
.text-sm { font-size: var(--font-size-sm); }
.text-base { font-size: var(--font-size-base); }
.text-lg { font-size: var(--font-size-lg); }
.text-xl { font-size: var(--font-size-xl); }
.text-2xl { font-size: var(--font-size-2xl); }
.text-3xl { font-size: var(--font-size-3xl); }

.font-light { font-weight: var(--font-weight-light); }
.font-normal { font-weight: var(--font-weight-normal); }
.font-medium { font-weight: var(--font-weight-medium); }
.font-semibold { font-weight: var(--font-weight-semibold); }
.font-bold { font-weight: var(--font-weight-bold); }

.text-primary { color: var(--color-primary); }
.text-secondary { color: var(--color-text-secondary); }
.text-muted { color: var(--color-text-muted); }

/* Display Utilities */
.block { display: block; }
.inline-block { display: inline-block; }
.inline { display: inline; }
.hidden { display: none; }

/* Position Utilities */
.relative { position: relative; }
.absolute { position: absolute; }
.fixed { position: fixed; }
.sticky { position: sticky; }

/* Visibility */
.visible { visibility: visible; }
.invisible { visibility: hidden; }

/* Overflow */
.overflow-hidden { overflow: hidden; }
.overflow-auto { overflow: auto; }
.overflow-scroll { overflow: scroll; }
.overflow-x-hidden { overflow-x: hidden; }
.overflow-y-hidden { overflow-y: hidden; }
.overflow-x-auto { overflow-x: auto; }
.overflow-y-auto { overflow-y: auto; }

/* Border Radius */
.rounded { border-radius: var(--radius-base); }
.rounded-md { border-radius: var(--radius-md); }
.rounded-lg { border-radius: var(--radius-lg); }
.rounded-xl { border-radius: var(--radius-xl); }
.rounded-full { border-radius: var(--radius-full); }

/* Shadows */
.shadow { box-shadow: var(--shadow-base); }
.shadow-sm { box-shadow: var(--shadow-sm); }
.shadow-md { box-shadow: var(--shadow-md); }
.shadow-lg { box-shadow: var(--shadow-lg); }
.shadow-xl { box-shadow: var(--shadow-xl); }
.shadow-none { box-shadow: none; }

/* Transitions */
.transition { transition: all var(--transition-base); }
.transition-fast { transition: all var(--transition-fast); }
.transition-slow { transition: all var(--transition-slow); }
.transition-none { transition: none; }

/* ==========================================================================
   Accessibility and Screen Reader Utilities
   ========================================================================== */

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.not-sr-only {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

/* Focus styles for better accessibility */
.focus-visible:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Skip links */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: var(--color-primary);
  color: white;
  padding: 8px;
  text-decoration: none;
  border-radius: var(--radius-md);
  z-index: var(--z-max);
}

.skip-link:focus {
  top: 6px;
}

/* ==========================================================================
   State Utilities
   ========================================================================== */

/* Loading states */
.loading {
  opacity: 0.6;
  pointer-events: none;
  cursor: wait;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error and success states */
.error {
  color: var(--color-error);
  border-color: var(--color-error);
}

.success {
  color: var(--color-success);
  border-color: var(--color-success);
}

.warning {
  color: var(--color-warning);
  border-color: var(--color-warning);
}

.info {
  color: var(--color-info);
  border-color: var(--color-info);
}

/* ==========================================================================
   Responsive Design
   ========================================================================== */

@media (min-width: 640px) {
  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .sm\\:flex-row { flex-direction: row; }
  .sm\\:text-left { text-align: left; }
  .sm\\:block { display: block; }
  .sm\\:hidden { display: none; }
}

@media (min-width: 768px) {
  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .md\\:flex-row { flex-direction: row; }
  .md\\:block { display: block; }
  .md\\:hidden { display: none; }
  .md\\:text-lg { font-size: var(--font-size-lg); }
  .md\\:text-xl { font-size: var(--font-size-xl); }
}

@media (min-width: 1024px) {
  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .lg\\:block { display: block; }
  .lg\\:hidden { display: none; }
  .lg\\:text-xl { font-size: var(--font-size-xl); }
  .lg\\:text-2xl { font-size: var(--font-size-2xl); }
}

/* ==========================================================================
   Print Styles
   ========================================================================== */

@media print {
  *,
  *::before,
  *::after {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
  }
  
  a,
  a:visited {
    text-decoration: underline;
  }
  
  a[href]:after {
    content: " (" attr(href) ")";
  }
  
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  
  thead {
    display: table-header-group;
  }
  
  tr,
  img {
    page-break-inside: avoid;
  }
  
  img {
    max-width: 100% !important;
  }
  
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  
  h2,
  h3 {
    page-break-after: avoid;
  }
  
  .no-print {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/globals.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAGzB,iCAAiC;;AAGjC;;+EAE+E;;AAE/E,qBAAqB;AACrB;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,sCAAsC;EACtC,sCAAsC;EACtC,wBAAwB;EACxB,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,2DAA2D;AAC3D;;EAEE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;;;EAGE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;;;;EAIE,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE;GACC,qBAAqB;EACtB;;EAEA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;;+EAE+E;;AAE/E,aAAa;AACb;EACE,uCAAuC;EACvC,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;;;;EAIE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,+BAA+B;EAC/B,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;+EAE+E;;AAE/E;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,0CAA0C;EAC1C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E,0CAA0C;AAC1C;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;EAGE,WAAW;EACX,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;;EAEE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,yDAAmP;EACnP,kDAAkD;EAClD,4BAA4B;EAC5B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;;EAEE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,cAAc;EACd,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,2BAA2B;AAC7B;;AAEA,gBAAgB,8BAA8B,EAAE;AAChD,gBAAgB,8BAA8B,EAAE;AAChD,gBAAgB,8BAA8B,EAAE;AAChD,iBAAiB,+BAA+B,EAAE;;AAElD,sBAAsB;AACtB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,YAAY,sBAAsB,EAAE;AACpC,YAAY,mBAAmB,EAAE;AACjC,aAAa,eAAe,EAAE;AAC9B,eAAe,iBAAiB,EAAE;;AAElC,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,mBAAmB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,iBAAiB,oBAAoB,EAAE;AACvC,kBAAkB,qBAAqB,EAAE;;AAEzC,iBAAiB,2BAA2B,EAAE;AAC9C,kBAAkB,uBAAuB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,6BAA6B,EAAE;;AAEjD,UAAU,YAAY,EAAE;AACxB,aAAa,cAAc,EAAE;AAC7B,gBAAgB,cAAc,EAAE;AAChC,aAAa,UAAU,EAAE;;AAEzB,mBAAmB;AACnB,QAAQ,aAAa,EAAE;AACvB,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;;AAEnE,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;;AAEhC,sBAAsB;AACtB,OAAO,SAAS,EAAE;AAClB,UAAU,YAAY,EAAE;AACxB,WAAW,iBAAiB,EAAE,kBAAkB,EAAE;AAClD,WAAW,gBAAgB,EAAE,mBAAmB,EAAE;;AAElD,OAAO,UAAU,EAAE;AACnB,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;;AAElC,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;;AAEzE,mBAAmB;AACnB,aAAa,gBAAgB,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC,cAAc,iBAAiB,EAAE;AACjC,gBAAgB,mBAAmB,EAAE;;AAErC,WAAW,8BAA8B,EAAE;AAC3C,WAAW,8BAA8B,EAAE;AAC3C,aAAa,gCAAgC,EAAE;AAC/C,WAAW,8BAA8B,EAAE;AAC3C,WAAW,8BAA8B,EAAE;AAC3C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;;AAE7C,cAAc,qCAAqC,EAAE;AACrD,eAAe,sCAAsC,EAAE;AACvD,eAAe,sCAAsC,EAAE;AACvD,iBAAiB,wCAAwC,EAAE;AAC3D,aAAa,oCAAoC,EAAE;;AAEnD,gBAAgB,2BAA2B,EAAE;AAC7C,kBAAkB,kCAAkC,EAAE;AACtD,cAAc,8BAA8B,EAAE;;AAE9C,sBAAsB;AACtB,SAAS,cAAc,EAAE;AACzB,gBAAgB,qBAAqB,EAAE;AACvC,UAAU,eAAe,EAAE;AAC3B,UAAU,aAAa,EAAE;;AAEzB,uBAAuB;AACvB,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;AAChC,SAAS,eAAe,EAAE;AAC1B,UAAU,gBAAgB,EAAE;;AAE5B,eAAe;AACf,WAAW,mBAAmB,EAAE;AAChC,aAAa,kBAAkB,EAAE;;AAEjC,aAAa;AACb,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,cAAc,EAAE;AACjC,mBAAmB,gBAAgB,EAAE;AACrC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,kBAAkB,EAAE;AACzC,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;;AAErC,kBAAkB;AAClB,WAAW,iCAAiC,EAAE;AAC9C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,gBAAgB,iCAAiC,EAAE;;AAEnD,YAAY;AACZ,UAAU,8BAA8B,EAAE;AAC1C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,eAAe,gBAAgB,EAAE;;AAEjC,gBAAgB;AAChB,cAAc,sCAAsC,EAAE;AACtD,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,gBAAgB,EAAE;;AAErC;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,QAAQ;AACV;;AAEA;;+EAE+E;;AAE/E,mBAAmB;AACnB;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,iBAAiB,gBAAgB,EAAE;EACnC,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;AAC/B;;AAEA;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,eAAe,8BAA8B,EAAE;EAC/C,eAAe,8BAA8B,EAAE;AACjD;;AAEA;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;AACnD;;AAEA;;+EAE+E;;AAE/E;EACE;;;IAGE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Import CSS Variables */\r\n@import './variables.css';\r\n\r\n/* Import Advanced CSS Features */\r\n@import './advanced.css';\r\n\r\n/* ==========================================================================\r\n   CSS Reset and Normalize\r\n   ========================================================================== */\r\n\r\n/* Modern CSS Reset */\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Remove default margins and paddings */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* HTML and Body */\r\nhtml {\r\n  font-size: 16px;\r\n  scroll-behavior: smooth;\r\n  -webkit-text-size-adjust: 100%;\r\n  -ms-text-size-adjust: 100%;\r\n  -moz-text-size-adjust: 100%;\r\n  text-size-adjust: 100%;\r\n  line-height: 1.15;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  font-family: var(--font-family-primary);\r\n  font-size: var(--font-size-base);\r\n  font-weight: var(--font-weight-normal);\r\n  line-height: var(--line-height-normal);\r\n  color: var(--color-text);\r\n  background-color: var(--color-background);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  text-rendering: optimizeLegibility;\r\n  font-feature-settings: \"kern\" 1;\r\n  font-kerning: normal;\r\n  min-height: 100vh;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Screen Reader Only Content */\r\n.sr-only {\r\n  position: absolute !important;\r\n  width: 1px !important;\r\n  height: 1px !important;\r\n  padding: 0 !important;\r\n  margin: -1px !important;\r\n  overflow: hidden !important;\r\n  clip: rect(0, 0, 0, 0) !important;\r\n  white-space: nowrap !important;\r\n  border: 0 !important;\r\n}\r\n\r\n.sr-only:focus {\r\n  position: static !important;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  padding: inherit !important;\r\n  margin: inherit !important;\r\n  overflow: visible !important;\r\n  clip: auto !important;\r\n  white-space: inherit !important;\r\n}\r\n\r\n/* Remove list styles on ul, ol elements with a list role */\r\nul[role='list'],\r\nol[role='list'] {\r\n  list-style: none;\r\n}\r\n\r\n/* Set core root defaults */\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/* Set core body defaults */\r\nbody {\r\n  text-rendering: optimizeSpeed;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* A elements that don't have a class get default styles */\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\n/* Make images easier to work with */\r\nimg,\r\npicture,\r\nsvg {\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n\r\n/* Remove built-in form typography styles */\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n/* Remove animations for people who've turned them off */\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n   scroll-behavior: auto;\r\n  }\r\n  \r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n  }\r\n}\r\n\r\n/* ==========================================================================\r\n   Typography System\r\n   ========================================================================== */\r\n\r\n/* Headings */\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-family: var(--font-family-heading);\r\n  font-weight: var(--font-weight-bold);\r\n  line-height: var(--line-height-tight);\r\n  color: var(--color-text);\r\n  margin-bottom: var(--spacing-4);\r\n  text-wrap: balance;\r\n}\r\n\r\nh1 {\r\n  font-size: var(--font-size-5xl);\r\n  font-weight: var(--font-weight-extrabold);\r\n  line-height: var(--line-height-tight);\r\n  letter-spacing: var(--letter-spacing-tight);\r\n}\r\n\r\nh2 {\r\n  font-size: var(--font-size-4xl);\r\n  font-weight: var(--font-weight-bold);\r\n  line-height: var(--line-height-tight);\r\n  letter-spacing: var(--letter-spacing-tight);\r\n}\r\n\r\nh3 {\r\n  font-size: var(--font-size-3xl);\r\n  font-weight: var(--font-weight-bold);\r\n  line-height: var(--line-height-snug);\r\n}\r\n\r\nh4 {\r\n  font-size: var(--font-size-2xl);\r\n  font-weight: var(--font-weight-semibold);\r\n  line-height: var(--line-height-snug);\r\n}\r\n\r\nh5 {\r\n  font-size: var(--font-size-xl);\r\n  font-weight: var(--font-weight-semibold);\r\n  line-height: var(--line-height-normal);\r\n}\r\n\r\nh6 {\r\n  font-size: var(--font-size-lg);\r\n  font-weight: var(--font-weight-medium);\r\n  line-height: var(--line-height-normal);\r\n}\r\n\r\n/* Paragraphs and Text */\r\np {\r\n  margin-bottom: var(--spacing-4);\r\n  color: var(--color-text-secondary);\r\n  line-height: var(--line-height-relaxed);\r\n  text-wrap: pretty;\r\n  orphans: 2;\r\n  widows: 2;\r\n}\r\n\r\np:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Strong and emphasis */\r\nstrong,\r\nb {\r\n  font-weight: var(--font-weight-bold);\r\n  color: var(--color-text);\r\n}\r\n\r\nem,\r\ni {\r\n  font-style: italic;\r\n}\r\n\r\n/* Small text */\r\nsmall {\r\n  font-size: var(--font-size-sm);\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n/* Code and preformatted text */\r\ncode,\r\nkbd,\r\nsamp,\r\npre {\r\n  font-family: var(--font-family-mono);\r\n  font-size: 0.9em;\r\n}\r\n\r\ncode {\r\n  background-color: var(--color-surface);\r\n  padding: var(--spacing-1) var(--spacing-2);\r\n  border-radius: var(--radius-sm);\r\n  color: var(--color-text);\r\n  border: 1px solid var(--color-border);\r\n}\r\n\r\npre {\r\n  background-color: var(--color-surface);\r\n  padding: var(--spacing-4);\r\n  border-radius: var(--radius-md);\r\n  overflow-x: auto;\r\n  border: 1px solid var(--color-border);\r\n  line-height: var(--line-height-relaxed);\r\n}\r\n\r\npre code {\r\n  background: none;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n/* Blockquotes */\r\nblockquote {\r\n  margin: var(--spacing-6) 0;\r\n  padding: var(--spacing-4) var(--spacing-6);\r\n  border-left: 4px solid var(--color-primary);\r\n  background-color: var(--color-surface);\r\n  border-radius: var(--radius-md);\r\n  font-style: italic;\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\nblockquote p {\r\n  margin-bottom: var(--spacing-2);\r\n}\r\n\r\nblockquote p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\nblockquote cite {\r\n  display: block;\r\n  margin-top: var(--spacing-2);\r\n  font-size: var(--font-size-sm);\r\n  color: var(--color-text-muted);\r\n  font-style: normal;\r\n}\r\n\r\nblockquote cite::before {\r\n  content: \"— \";\r\n}\r\n\r\n/* ==========================================================================\r\n   Links and Navigation\r\n   ========================================================================== */\r\n\r\na {\r\n  color: var(--color-primary);\r\n  text-decoration: none;\r\n  transition: color var(--transition-fast);\r\n  cursor: pointer;\r\n}\r\n\r\na:hover {\r\n  color: var(--color-primary-light);\r\n  text-decoration: underline;\r\n}\r\n\r\na:focus {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\na:focus:not(:focus-visible) {\r\n  outline: none;\r\n}\r\n\r\na:focus-visible {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n/* External links */\r\na[href^=\"http\"]:not([href*=\"s-cubus.com\"]):not(.btn)::after {\r\n  content: \" ↗\";\r\n  font-size: 0.8em;\r\n  opacity: 0.7;\r\n}\r\n\r\na.btn:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n/* ==========================================================================\r\n   Lists\r\n   ========================================================================== */\r\n\r\nul, ol {\r\n  margin-bottom: var(--spacing-4);\r\n  padding-left: var(--spacing-6);\r\n}\r\n\r\nul {\r\n  list-style-type: disc;\r\n}\r\n\r\nol {\r\n  list-style-type: decimal;\r\n}\r\n\r\nli {\r\n  margin-bottom: var(--spacing-2);\r\n  color: var(--color-text-secondary);\r\n  line-height: var(--line-height-relaxed);\r\n}\r\n\r\nli:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Nested lists */\r\nli ul,\r\nli ol {\r\n  margin-top: var(--spacing-2);\r\n  margin-bottom: var(--spacing-2);\r\n}\r\n\r\n/* Description lists */\r\ndl {\r\n  margin-bottom: var(--spacing-4);\r\n}\r\n\r\ndt {\r\n  font-weight: var(--font-weight-semibold);\r\n  color: var(--color-text);\r\n  margin-bottom: var(--spacing-1);\r\n}\r\n\r\ndd {\r\n  margin-bottom: var(--spacing-3);\r\n  margin-left: var(--spacing-4);\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n/* ==========================================================================\r\n   Tables\r\n   ========================================================================== */\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-bottom: var(--spacing-6);\r\n  background-color: var(--color-surface);\r\n  border-radius: var(--radius-lg);\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\nthead {\r\n  background-color: var(--color-surface-elevated);\r\n}\r\n\r\nth,\r\ntd {\r\n  padding: var(--spacing-3) var(--spacing-4);\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--color-border);\r\n}\r\n\r\nth {\r\n  font-weight: var(--font-weight-semibold);\r\n  color: var(--color-text);\r\n  font-size: var(--font-size-sm);\r\n  text-transform: uppercase;\r\n  letter-spacing: var(--letter-spacing-wide);\r\n}\r\n\r\ntd {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\ntbody tr:hover {\r\n  background-color: var(--color-surface);\r\n}\r\n\r\ntbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* ==========================================================================\r\n   Forms and Inputs\r\n   ========================================================================== */\r\n\r\n/* Form elements inherit font properties */\r\ninput,\r\ntextarea,\r\nselect,\r\nbutton {\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n  color: inherit;\r\n}\r\n\r\n/* Form controls */\r\ninput,\r\ntextarea,\r\nselect {\r\n  width: 100%;\r\n  padding: var(--spacing-3) var(--spacing-4);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-md);\r\n  background-color: var(--color-surface);\r\n  color: var(--color-text);\r\n  transition: all var(--transition-fast);\r\n  appearance: none;\r\n}\r\n\r\ninput:focus,\r\ntextarea:focus,\r\nselect:focus {\r\n  outline: none;\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);\r\n}\r\n\r\ninput::placeholder,\r\ntextarea::placeholder {\r\n  color: var(--color-text-muted);\r\n  opacity: 1;\r\n}\r\n\r\n/* Specific input types */\r\ninput[type=\"search\"] {\r\n  -webkit-appearance: textfield;\r\n}\r\n\r\ninput[type=\"search\"]::-webkit-search-decoration,\r\ninput[type=\"search\"]::-webkit-search-cancel-button {\r\n  -webkit-appearance: none;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-outer-spin-button,\r\ninput[type=\"number\"]::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Textarea */\r\ntextarea {\r\n  resize: vertical;\r\n  min-height: 100px;\r\n}\r\n\r\n/* Select */\r\nselect {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n  background-position: right var(--spacing-3) center;\r\n  background-repeat: no-repeat;\r\n  background-size: 16px 12px;\r\n  padding-right: var(--spacing-10);\r\n}\r\n\r\n/* Checkboxes and radio buttons */\r\ninput[type=\"checkbox\"],\r\ninput[type=\"radio\"] {\r\n  width: auto;\r\n  margin-right: var(--spacing-2);\r\n  accent-color: var(--color-primary);\r\n}\r\n\r\n/* Labels */\r\nlabel {\r\n  display: block;\r\n  margin-bottom: var(--spacing-2);\r\n  font-weight: var(--font-weight-medium);\r\n  color: var(--color-text);\r\n  cursor: pointer;\r\n}\r\n\r\n/* Fieldsets */\r\nfieldset {\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-md);\r\n  padding: var(--spacing-4);\r\n  margin-bottom: var(--spacing-4);\r\n}\r\n\r\nlegend {\r\n  font-weight: var(--font-weight-semibold);\r\n  color: var(--color-text);\r\n  padding: 0 var(--spacing-2);\r\n}\r\n\r\n/* ==========================================================================\r\n   Buttons\r\n   ========================================================================== */\r\n\r\nbutton {\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  padding: var(--spacing-3) var(--spacing-6);\r\n  font-weight: var(--font-weight-medium);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--spacing-2);\r\n  transition: all var(--transition-fast);\r\n  position: relative;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\nbutton:focus {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n}\r\n\r\nbutton:focus:not(:focus-visible) {\r\n  outline: none;\r\n}\r\n\r\nbutton:focus-visible {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Button Variants */\r\n.btn-primary {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n  border: 2px solid var(--color-primary);\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  background-color: var(--color-primary-light);\r\n  border-color: var(--color-primary-light);\r\n  color: #f59e0b;\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-primary:active {\r\n  transform: translateY(0);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: var(--color-secondary);\r\n  color: white;\r\n  border: 2px solid var(--color-secondary);\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  background-color: var(--color-secondary-light);\r\n  border-color: var(--color-secondary-light);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-outline {\r\n  background-color: transparent;\r\n  color: var(--color-primary);\r\n  border: 2px solid var(--color-primary);\r\n}\r\n\r\n.btn-outline:hover:not(:disabled) {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-ghost {\r\n  background-color: transparent;\r\n  color: var(--color-text);\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.btn-ghost:hover:not(:disabled) {\r\n  background-color: var(--color-surface);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n.btn-success {\r\n  background-color: var(--color-success);\r\n  color: white;\r\n  border: 2px solid var(--color-success);\r\n}\r\n\r\n.btn-success:hover:not(:disabled) {\r\n  background-color: var(--color-success-light);\r\n  border-color: var(--color-success-light);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-warning {\r\n  background-color: var(--color-warning);\r\n  color: white;\r\n  border: 2px solid var(--color-warning);\r\n}\r\n\r\n.btn-warning:hover:not(:disabled) {\r\n  background-color: var(--color-warning-light);\r\n  border-color: var(--color-warning-light);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-error {\r\n  background-color: var(--color-error);\r\n  color: white;\r\n  border: 2px solid var(--color-error);\r\n}\r\n\r\n.btn-error:hover:not(:disabled) {\r\n  background-color: var(--color-error-light);\r\n  border-color: var(--color-error-light);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* ==========================================================================\r\n   Media Elements\r\n   ========================================================================== */\r\n\r\n/* Images */\r\nimg {\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n/* Figures */\r\nfigure {\r\n  margin: var(--spacing-6) 0;\r\n}\r\n\r\nfigcaption {\r\n  margin-top: var(--spacing-2);\r\n  font-size: var(--font-size-sm);\r\n  color: var(--color-text-muted);\r\n  text-align: center;\r\n  font-style: italic;\r\n}\r\n\r\n/* Audio and Video */\r\naudio,\r\nvideo {\r\n  width: 100%;\r\n  height: auto;\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n/* ==========================================================================\r\n   Utility Classes - Layout\r\n   ========================================================================== */\r\n\r\n.container {\r\n  width: 100%;\r\n  max-width: var(--container-xl);\r\n  margin: 0 auto;\r\n  padding: 0 var(--spacing-4);\r\n}\r\n\r\n.container-sm { max-width: var(--container-sm); }\r\n.container-md { max-width: var(--container-md); }\r\n.container-lg { max-width: var(--container-lg); }\r\n.container-2xl { max-width: var(--container-2xl); }\r\n\r\n/* Flexbox Utilities */\r\n.flex { display: flex; }\r\n.inline-flex { display: inline-flex; }\r\n.flex-col { flex-direction: column; }\r\n.flex-row { flex-direction: row; }\r\n.flex-wrap { flex-wrap: wrap; }\r\n.flex-nowrap { flex-wrap: nowrap; }\r\n\r\n.items-start { align-items: flex-start; }\r\n.items-center { align-items: center; }\r\n.items-end { align-items: flex-end; }\r\n.items-stretch { align-items: stretch; }\r\n.items-baseline { align-items: baseline; }\r\n\r\n.justify-start { justify-content: flex-start; }\r\n.justify-center { justify-content: center; }\r\n.justify-end { justify-content: flex-end; }\r\n.justify-between { justify-content: space-between; }\r\n.justify-around { justify-content: space-around; }\r\n.justify-evenly { justify-content: space-evenly; }\r\n\r\n.flex-1 { flex: 1 1 0%; }\r\n.flex-auto { flex: 1 1 auto; }\r\n.flex-initial { flex: 0 1 auto; }\r\n.flex-none { flex: none; }\r\n\r\n/* Grid Utilities */\r\n.grid { display: grid; }\r\n.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }\r\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\r\n.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }\r\n\r\n.gap-1 { gap: var(--spacing-1); }\r\n.gap-2 { gap: var(--spacing-2); }\r\n.gap-3 { gap: var(--spacing-3); }\r\n.gap-4 { gap: var(--spacing-4); }\r\n.gap-6 { gap: var(--spacing-6); }\r\n.gap-8 { gap: var(--spacing-8); }\r\n\r\n/* Spacing Utilities */\r\n.m-0 { margin: 0; }\r\n.m-auto { margin: auto; }\r\n.mx-auto { margin-left: auto; margin-right: auto; }\r\n.my-auto { margin-top: auto; margin-bottom: auto; }\r\n\r\n.p-0 { padding: 0; }\r\n.p-4 { padding: var(--spacing-4); }\r\n.p-6 { padding: var(--spacing-6); }\r\n.p-8 { padding: var(--spacing-8); }\r\n\r\n.px-4 { padding-left: var(--spacing-4); padding-right: var(--spacing-4); }\r\n.py-4 { padding-top: var(--spacing-4); padding-bottom: var(--spacing-4); }\r\n\r\n/* Text Utilities */\r\n.text-left { text-align: left; }\r\n.text-center { text-align: center; }\r\n.text-right { text-align: right; }\r\n.text-justify { text-align: justify; }\r\n\r\n.text-xs { font-size: var(--font-size-xs); }\r\n.text-sm { font-size: var(--font-size-sm); }\r\n.text-base { font-size: var(--font-size-base); }\r\n.text-lg { font-size: var(--font-size-lg); }\r\n.text-xl { font-size: var(--font-size-xl); }\r\n.text-2xl { font-size: var(--font-size-2xl); }\r\n.text-3xl { font-size: var(--font-size-3xl); }\r\n\r\n.font-light { font-weight: var(--font-weight-light); }\r\n.font-normal { font-weight: var(--font-weight-normal); }\r\n.font-medium { font-weight: var(--font-weight-medium); }\r\n.font-semibold { font-weight: var(--font-weight-semibold); }\r\n.font-bold { font-weight: var(--font-weight-bold); }\r\n\r\n.text-primary { color: var(--color-primary); }\r\n.text-secondary { color: var(--color-text-secondary); }\r\n.text-muted { color: var(--color-text-muted); }\r\n\r\n/* Display Utilities */\r\n.block { display: block; }\r\n.inline-block { display: inline-block; }\r\n.inline { display: inline; }\r\n.hidden { display: none; }\r\n\r\n/* Position Utilities */\r\n.relative { position: relative; }\r\n.absolute { position: absolute; }\r\n.fixed { position: fixed; }\r\n.sticky { position: sticky; }\r\n\r\n/* Visibility */\r\n.visible { visibility: visible; }\r\n.invisible { visibility: hidden; }\r\n\r\n/* Overflow */\r\n.overflow-hidden { overflow: hidden; }\r\n.overflow-auto { overflow: auto; }\r\n.overflow-scroll { overflow: scroll; }\r\n.overflow-x-hidden { overflow-x: hidden; }\r\n.overflow-y-hidden { overflow-y: hidden; }\r\n.overflow-x-auto { overflow-x: auto; }\r\n.overflow-y-auto { overflow-y: auto; }\r\n\r\n/* Border Radius */\r\n.rounded { border-radius: var(--radius-base); }\r\n.rounded-md { border-radius: var(--radius-md); }\r\n.rounded-lg { border-radius: var(--radius-lg); }\r\n.rounded-xl { border-radius: var(--radius-xl); }\r\n.rounded-full { border-radius: var(--radius-full); }\r\n\r\n/* Shadows */\r\n.shadow { box-shadow: var(--shadow-base); }\r\n.shadow-sm { box-shadow: var(--shadow-sm); }\r\n.shadow-md { box-shadow: var(--shadow-md); }\r\n.shadow-lg { box-shadow: var(--shadow-lg); }\r\n.shadow-xl { box-shadow: var(--shadow-xl); }\r\n.shadow-none { box-shadow: none; }\r\n\r\n/* Transitions */\r\n.transition { transition: all var(--transition-base); }\r\n.transition-fast { transition: all var(--transition-fast); }\r\n.transition-slow { transition: all var(--transition-slow); }\r\n.transition-none { transition: none; }\r\n\r\n/* ==========================================================================\r\n   Accessibility and Screen Reader Utilities\r\n   ========================================================================== */\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.not-sr-only {\r\n  position: static;\r\n  width: auto;\r\n  height: auto;\r\n  padding: 0;\r\n  margin: 0;\r\n  overflow: visible;\r\n  clip: auto;\r\n  white-space: normal;\r\n}\r\n\r\n/* Focus styles for better accessibility */\r\n.focus-visible:focus-visible {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Skip links */\r\n.skip-link {\r\n  position: absolute;\r\n  top: -40px;\r\n  left: 6px;\r\n  background: var(--color-primary);\r\n  color: white;\r\n  padding: 8px;\r\n  text-decoration: none;\r\n  border-radius: var(--radius-md);\r\n  z-index: var(--z-max);\r\n}\r\n\r\n.skip-link:focus {\r\n  top: 6px;\r\n}\r\n\r\n/* ==========================================================================\r\n   State Utilities\r\n   ========================================================================== */\r\n\r\n/* Loading states */\r\n.loading {\r\n  opacity: 0.6;\r\n  pointer-events: none;\r\n  cursor: wait;\r\n}\r\n\r\n.spinner {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 2px solid transparent;\r\n  border-top: 2px solid currentColor;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Error and success states */\r\n.error {\r\n  color: var(--color-error);\r\n  border-color: var(--color-error);\r\n}\r\n\r\n.success {\r\n  color: var(--color-success);\r\n  border-color: var(--color-success);\r\n}\r\n\r\n.warning {\r\n  color: var(--color-warning);\r\n  border-color: var(--color-warning);\r\n}\r\n\r\n.info {\r\n  color: var(--color-info);\r\n  border-color: var(--color-info);\r\n}\r\n\r\n/* ==========================================================================\r\n   Responsive Design\r\n   ========================================================================== */\r\n\r\n@media (min-width: 640px) {\r\n  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .sm\\:flex-row { flex-direction: row; }\r\n  .sm\\:text-left { text-align: left; }\r\n  .sm\\:block { display: block; }\r\n  .sm\\:hidden { display: none; }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n  .md\\:flex-row { flex-direction: row; }\r\n  .md\\:block { display: block; }\r\n  .md\\:hidden { display: none; }\r\n  .md\\:text-lg { font-size: var(--font-size-lg); }\r\n  .md\\:text-xl { font-size: var(--font-size-xl); }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n  .lg\\:block { display: block; }\r\n  .lg\\:hidden { display: none; }\r\n  .lg\\:text-xl { font-size: var(--font-size-xl); }\r\n  .lg\\:text-2xl { font-size: var(--font-size-2xl); }\r\n}\r\n\r\n/* ==========================================================================\r\n   Print Styles\r\n   ========================================================================== */\r\n\r\n@media print {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    background: white !important;\r\n    color: black !important;\r\n    box-shadow: none !important;\r\n  }\r\n  \r\n  a,\r\n  a:visited {\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  a[href]:after {\r\n    content: \" (\" attr(href) \")\";\r\n  }\r\n  \r\n  abbr[title]:after {\r\n    content: \" (\" attr(title) \")\";\r\n  }\r\n  \r\n  pre,\r\n  blockquote {\r\n    border: 1px solid #999;\r\n    page-break-inside: avoid;\r\n  }\r\n  \r\n  thead {\r\n    display: table-header-group;\r\n  }\r\n  \r\n  tr,\r\n  img {\r\n    page-break-inside: avoid;\r\n  }\r\n  \r\n  img {\r\n    max-width: 100% !important;\r\n  }\r\n  \r\n  p,\r\n  h2,\r\n  h3 {\r\n    orphans: 3;\r\n    widows: 3;\r\n  }\r\n  \r\n  h2,\r\n  h3 {\r\n    page-break-after: avoid;\r\n  }\r\n  \r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
